<button mat-button (click)="goBack()" ><i class="fa fa-caret-square-left"></i><span>Back</span></button>
<button mat-button (click)="deleteCampaign()" *ngIf="campaignId?.length > 0"><i class="fa fa-times"></i><span>Delete</span></button>